import { Route, Switch } from 'wouter';
import { AuthProvider } from './hooks/useAuth';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppShell } from './components/layout/AppShell';
import { ChatPage } from './pages/ChatPage';
import { SessionsPage } from './pages/SessionsPage';
import { SettingsPage } from './pages/SettingsPage';

export default function App() {
  return (
    <AuthProvider>
      <ProtectedRoute>
        <AppShell>
          <Switch>
            <Route path="/" component={ChatPage} />
            <Route path="/sessions" component={SessionsPage} />
            <Route path="/settings" component={SettingsPage} />
            <Route>
              <div className="p-6 text-center text-bark">Not found</div>
            </Route>
          </Switch>
        </AppShell>
      </ProtectedRoute>
    </AuthProvider>
  );
}
